import { Staff as PBStaff } from "gen/company/models_pb"
import { UUID as PBUUID } from "gen/proto/uuid/models_pb"
import { useMemo } from "react"
import { useIdFilter } from "shared-ts/hooks/useFilter"

import { useSearchStaffs } from "features/api/search"
import { useWebFilter, UseWebFilterProps } from "hooks/filters/useWebFilter"
import { Staff } from "lib/staff"

export function useClerkFilter({
  persistInUrl = true,
  key = "clerk",
  label = "Clerk",
  initialSelectedOptions = [],
  skip = false,
  meId,
}: Partial<
  Pick<
    UseWebFilterProps<unknown>,
    "persistInUrl" | "key" | "label" | "initialSelectedOptions"
  >
> & { skip?: boolean; meId?: PBUUID } = {}) {
  const { results, setQuery, loadNext } = useSearchStaffs(undefined, { skip })

  const staffs = useMemo(() => {
    const staffs: PBStaff[] = []
    if (meId) staffs.push(PBStaff.create({ id: meId, firstName: "Me" }))
    for (const { staff } of results) {
      if (!staff) continue
      staffs.push(staff)
    }
    return staffs
  }, [results, meId])

  const { filter, selected: selectedClerkIds } = useIdFilter({
    key,
    label,
    values: staffs,
    labelExtractor: (staff) => Staff.fromPB(staff).fullName,
    onChangeQuery: setQuery,
    autoFilterOptions: false,
    allowExternalValues: true,
    onLoadMore: loadNext,
    useFilter: (props) => {
      return useWebFilter({
        ...props,
        persistInUrl,
        initialSelectedOptions,
      })
    },
  })

  return { filter, selectedClerkIds }
}
